import feathers from '@feathersjs/client';
import { cacheBefore, cacheAfter } from 'src/feathers/hooks';
const { GeneralError } = feathers.errors;

class Service {
  constructor(options) {
    this.options = options || {};
  }

  setup(app) {
    this.geocodeService = new window.google.maps.Geocoder();
  }

  async find(params) {
    const googleParams = {
      ...params.query
    };
    return new Promise((resolve, reject) => {
      this.geocodeService.geocode(googleParams, (response, status) => {
        if (status !== 'OK') {
          reject(
            new GeneralError(
              'There was an error from Google calculating the geocode.',
              { status }
            )
          );
        } else {
          resolve(response[0]);
        }
      });
    });
  }
}

export default (app) => {
  app.use('google/geocode', new Service());
  const service = app.service('google/geocode');

  service.hooks({
    before: {
      all: [],
      find: [cacheBefore],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    },

    after: {
      all: [],
      find: [cacheAfter],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    },

    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });
};
